module.exports = __webpack_public_path__ + "media/images/emblems/Villigen-blason-e0ccc3f6b9a28abf5914c8dcc0dd27a6.png";